import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton, Box } from '@mui/material';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { FaUserCircle, FaTimes } from 'react-icons/fa';
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { toast } from 'react-toastify';
import { useDispatch } from "react-redux";

import { auth } from '../firebase/firebase';

import { REMOVE_ACTIVE_USER, SET_ACTIVE_USER } from '../redux/slice/authSlice';
//import { selectIsLoggedIn } from '../redux/slice/authSlice';

import ShowOnLogin, { ShowOnLogout } from './hiddenlinks/hiddenLink';

import { AdminOnlyLink } from "./admin/adminOnlyRoute/AdminOnlyRoute";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);  
  const [displayName, setDisplayName] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        let currentDisplayName = user.displayName;

        if (user.displayName == null) {
          currentDisplayName = user.email.substring(0, user.email.indexOf("@"));
          currentDisplayName = currentDisplayName.charAt(0).toUpperCase() + currentDisplayName.slice(1);
        }
        setDisplayName(currentDisplayName);

        dispatch(SET_ACTIVE_USER({
          email: user.email,
          userName: currentDisplayName,
          userID: user.uid
        }));

      } else {
        setDisplayName("");
        dispatch(REMOVE_ACTIVE_USER());
      }
    });

    return () => unsubscribe();
  }, [dispatch]);

  const toggleMenu = () => {
   setShowMenu(!showMenu);
};
 const hideMenu = () => {
   setShowMenu(false);
  };

  const logoutUser = () => {
    signOut(auth).then(() => {
      toast.success("Logout Successfully.");
      navigate("/");
    }).catch((error) => {
      toast.error(error.message);
    });
  }; 
  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(6, 0, 16, 0.17)', 
        backdropFilter: 'blur(5px)',
        filter: 'brightness(80%)'
      }}
    >
       <Toolbar sx={{ justifyContent: 'space-between' }}>
       <Typography
          variant="h6"
          component={Link}
          to="/"
          sx={{ flexGrow: 1, textDecoration: 'none', color: 'white' }}
          aria-label="Go to Task Manager homepage"
        >
          Task Manager
        
        </Typography>
        <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
          <AdminOnlyLink>
            <Button component={Link} to="/admin" variant="contained" color="primary" sx={{ color: 'white' }}>
              Admin
            </Button>
          </AdminOnlyLink>
          <Button component={NavLink} to="/" color="inherit" sx={{ '&.active': { fontWeight: 'bold', color: '#ff7722' } }}>
            Home
          </Button>
          <Button component={NavLink} to="/contact" color="inherit" sx={{ '&.active': { fontWeight: 'bold', color: '#ff7722' } }}>
            Contact Us
          </Button>
          <ShowOnLogout>
            <Button component={NavLink} to="/login" color="inherit" sx={{ '&.active': { fontWeight: 'bold', color: '#ff7722' } }}>
              Login
            </Button>
          </ShowOnLogout>
          <ShowOnLogin>
            <Typography variant="body1" sx={{ color: '#ff7722', display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <FaUserCircle size={16} /> Hi, {displayName}
            </Typography>
            <Button component={NavLink} to="/tasks" color="inherit" sx={{ '&.active': { fontWeight: 'bold', color: '#ff7722' } }}>
              My Tasks
            </Button>
            <Button onClick={logoutUser} color="inherit">
              Logout
            </Button>
          </ShowOnLogin>
        </Box>

      
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
         
          <IconButton color="inherit" onClick={toggleMenu} aria-label="Open menu">
            <HiOutlineMenuAlt3 size={28} />
          </IconButton>
        </Box>
      </Toolbar>
      {showMenu && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            zIndex: (theme) => theme.zIndex.drawer + 2, 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 3,
            color: 'white',
          }}
          onClick={hideMenu} 
        >
          <IconButton
            onClick={hideMenu}
            sx={{ position: 'absolute', top: 16, right: 16, color: 'white' }}
            aria-label="Close menu"
          >
            <FaTimes size={22} />
          </IconButton>

          <AdminOnlyLink>
            <Button component={Link} to="/admin" variant="contained" color="primary" sx={{ color: 'white', fontSize: '1.2rem', padding: '10px 20px' }}>
              Admin
            </Button>
          </AdminOnlyLink>
          <Button component={NavLink} to="/" color="inherit" sx={{ '&.active': { fontWeight: 'bold', color: '#ff7722' }, fontSize: '1.2rem' }}>
            Home
          </Button>
          <Button component={NavLink} to="/contact" color="inherit" sx={{ '&.active': { fontWeight: 'bold', color: '#ff7722' }, fontSize: '1.2rem' }}>
            Contact Us
          </Button>

          <ShowOnLogout>
            <Button component={NavLink} to="/login" color="inherit" sx={{ '&.active': { fontWeight: 'bold', color: '#ff7722' }, fontSize: '1.2rem' }}>
              Login
            </Button>
          </ShowOnLogout>
          <ShowOnLogin>
            <Typography variant="h6" sx={{ color: '#ff7722', display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <FaUserCircle size={20} /> Hi, {displayName}
            </Typography>
            
        <Button onClick={logoutUser} color="inherit" sx={{ fontSize: '1.2rem' }}>
              Logout
            </Button>
          </ShowOnLogin>
        </Box>
      )}
    </AppBar>
  );
};

export default Navbar;
